import requester from 'utils/requester';
import { INIT_UI_LANGUAGE } from 'constants/languages';
import apiCubic from 'config/api-cubic';

export const createPaymentLink = async ({ cost, contractCode, customerRef, payeeId, description, isTVOD }) => {
  const { data: tokenKey } = await apiCubic.post({
    endpoint: apiCubic.endpoints.getLoginToken,
    data: {
      ottCustomerId: customerRef,
    },
  });

  const params = new URLSearchParams({ lang: INIT_UI_LANGUAGE, contractCode, tokenKey: tokenKey.token });

  if (isTVOD) params.append('reason', 'tvod');

  const successUrl = `https://my-tv.volia.com/portmone/success/webtv?${params}`;

  const response = await requester({
    method: 'post',
    url: 'https://gate.portmone.com.ua/',
    extendHeadersWithSession: false,
    appendParams: false,
    data: {
      query: 'createLinkPayment',
      paymentTypes: {
        gpay: 'N',
        card: 'Y',
      },
      priorityPaymentTypes: {
        gpay: '2',
        card: '1',
      },
      payee: {
        payeeId: payeeId,
        login: '',
        dt: '',
        signature: '',
        shopSiteId: '',
      },
      order: {
        description: description,
        shopOrderNumber: '',
        billAmount: cost,
        attribute1: '',
        attribute2: '',
        attribute3: '',
        attribute4: '',
        attribute5: '',
        successUrl: successUrl,
        failureUrl: '',
        preauthFlag: 'N',
        billCurrency: 'UAH',
        encoding: '',
      },
      token: {
        tokenFlag: 'N',
        returnToken: 'Y',
        token: '',
        cardMask: '',
        otherPaymentMethods: '',
      },
      payer: {
        lang: INIT_UI_LANGUAGE,
        emailAddress: '',
        showEmail: 'N',
      },
    },
  });

  return response;
};
